/**
 * Representation of the Users "Own" Selection
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { Selection };

class Selection {

	constructor(model) {
		// Model Reference for Lookups
		this.model = model;
		this.list = [];
		this.retrieve();
	}
	
	/*	Update the Persistent Store of this selections state */
	persist() {
		let storage = window.localStorage;
		let idList = this.list.reduce( (acc, work) => { return  acc + work.getID() + ","; }, "");
		storage.setItem("kunstraum.self.data", idList);
	}

	/* Retrieve this selections state from the local storage */
	retrieve() {
		let storage = window.localStorage;
		let idList = storage.getItem("kunstraum.self.data");
		let ids = idList != null? idList.split(",") : [];

		// build the list
		this.list.length = 0;
		for (let i = 0; i < ids.length; i++) {
			let id = ids [i];
			if (isNaN(id) == false) {
				let work = this.model.getWorks().getByID(ids [i]);
				if (work != null) {
					work.setIsInSelection(true);
					this.list.push(work);
				}
			}
		}
	}

	/*	Add a Work to the User Selection */
	addWork(work) {
		if (work.constructor.name == "WorkInExhibition") {
			work = work.getWork();
		}

		if (this.list.indexOf(work) == -1) {
			work.setIsInSelection(true);
			this.list.push(work);
			this.persist();
		}
	}

	/* Remove a Work from the User Selection */
	removeWork(work) {
		if (work.constructor.name == "WorkInExhibition") {
			work = work.getWork();
		}

		let index = this.list.indexOf(work);
		if (index != -1) {
			work.setIsInSelection(false);
			this.list.splice(index, 1);
			this.persist();
		}
	}

	/* Get the User Selection as a List */
	getList() {
		return this.list;
	}

	/*	Get the URL Encoded Link */
	getLink() {
		let buffer = "";
		for (let i = 0; i < this.list.length; i++) {
			let work = this.list [i];
			let id = work.getID().toString(); 
			for (let j = 0; j < id.length; j++) {
				let char = parseInt(id.charAt(j));
				buffer += String.fromCharCode(65 + char);
			}
			buffer += "K";
		}
		return buffer;
	}

	/*	Parse the selection from a link */
	parseLink(link) {
		try {
			// remove old
			while (this.list.length > 0) {
				this.removeWork(this.list [0]);
			}

			// add new
			let buffer = "";
			for (let i = 0; i < link.length; i++) {
				let number = link.charCodeAt(i) - 65;
				if (number == 10) {
					let id = parseInt(buffer);
					buffer = "";
					let work = this.model.getWorks().getByID(id);
					if (work != null) {
						this.addWork(work);
					}
				} else {
					buffer += number.toString();
				}
			}
		} catch (e) {
			console.log(e);
		}
	}


}